export default "__VITE_ASSET__P$8mCGMb__"